import React from "react";
import "../styles/Main.css";
import "../styles/Expertise.css";
import Card from "../components/Card";

// images
import messageappPng from "../images/portfolio/messageapp.png";
import scoialPng from "../images/portfolio/social.png";
import moveisPng from "../images/portfolio/movies.png";
import todoPng from "../images/portfolio/todo.png";
import withdrawPng from "../images/portfolio/withdraw.png";
import drumPng from "../images/portfolio/drum.png";
import gameoflifePng from "../images/portfolio/gameoflife.jpg";

const Main = () => {
  return (
    <React.Fragment>
      <div className="content ">
        <Card
          URL="https://xeyal-i.github.io/messageapp"
          image={messageappPng}
          title="Message App"
          info="React, Redux"
        />
        <Card
          URL="https://xeyal-i.github.io/socialapp"
          image={scoialPng}
          title="Social App"
          info="React Redux Firebase"
        />

        <Card
          URL="https://xeyal-i.github.io/ratemovies"
          image={moveisPng}
          title="Movie Ratings"
          info="React App"
        />

        <Card
          URL="https://xeyal-i.github.io/todoappjs"
          image={todoPng}
          title="To Do App"
          info="Vanilla JS"
        />
      </div>
      <div className="content">
        <Card
          URL="https://xeyal-i.github.io/withdraw"
          image={withdrawPng}
          title="Withdraw Money"
          info="Redux React"
        />
        <Card
          URL="https://xeyal-i.github.io/drum"
          image={drumPng}
          title="Drum Kit"
          info="Vanilla JS"
        />
        <Card
          URL="https://xeyal-i.github.io/reactgameoflife"
          image={gameoflifePng}
          title="Game Of life"
          info="React App"
        />
      </div>
    </React.Fragment>
  );
};

export default Main;
